import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '@uniqcamp/shared';
import { canAccessPrincipalFeatures } from '../utils/roles';
import { useFeatureAccess } from '../hooks/useFeatureAccess';

const Notifications: React.FC = () => {
  const navigate = useNavigate();
  const user = authService.getStoredUser();
  const isPrincipal = user && canAccessPrincipalFeatures(user.role);
  const { canView, loading: featureLoading } = useFeatureAccess('notifications');

  React.useEffect(() => {
    if (featureLoading) return;
    if (!isPrincipal && !canView) navigate('/meetings', { replace: true });
  }, [isPrincipal, canView, featureLoading, navigate]);

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5" component="h1" fontWeight={600} sx={{ mb: 2 }}>
        Notifications
      </Typography>
      <Typography variant="body2" color="text.secondary">
        View and manage notifications.
      </Typography>
    </Box>
  );
};

export default Notifications;
